export const conference = {
    "入会注意事项(必读)":"入会注意事项(必读)",
    "(1/3)请选择“加入会议”下载/调起腾讯会议app进入会议":"(1/3)请选择“加入会议”下载/调起腾讯会议app进入会议；",
    "(2/3)请务必使用与课堂派注册/绑定的手机":"(2/3)请务必使用与课堂派注册/绑定的手机；",
    "登陆腾讯会议":"登陆腾讯会议；",
    "(3/3)登陆后选择“课堂派”账号后直接进入会议":"(3/3)登陆后选择“课堂派”账号后直接进入会议；",
    "知道了":"知道了",
    "距开始":"距开始",
    "距离开始时间":"",
    "主持人":"主持人：",
    "来自":"来自：",
    "会议名称":"会议名称",
    "开始时间":"开始时间",
    "结束时间":"结束时间",
    "会议简介":"会议简介",
    "应用环节":"应用环节",
    "所属章节":"所属章节",
    "同时发布给学生":"同时发布给学生",
    "会议添加成功":"会议添加成功！",
    "更新成功":"更新成功！",
    "预约的会议":"预约的会议",
    "正在跳转至腾讯会议请稍候":"正在跳转至腾讯会议，请稍候……",
    "选择本次会议的录屏":"选择本次会议的录屏：",
    "录屏":"录屏",
    "确定关联":"确定关联",
    "关联成功":"关联成功",
    "关联后的录屏可在会议详情中查看":"关联后的录屏可在会议详情中查看",
    "暂无会议回放录屏":"暂无会议回放录屏!",
    "去关联录屏":"去关联录屏",
    "倒计时":"倒计时:",
    "学生下载权限设置":"学生下载权限设置",
    "重新关联":"重新关联",
    "权限设置":"权限设置",
    "修改会议":"修改会议",
    "取消会议":"取消会议",
    "复制邀请":"复制邀请",
    "您是否要删除该直播回放":"您是否要删除该直播回放",
    "邀请信息复制成功":"邀请信息复制成功",
    "复制失败":"复制失败",
    "确定要删除会议吗":"确定要删除会议吗",
    "再看看":"再看看",
    "确定要取消会议吗":"确定要取消会议吗",
    "取消成功":"取消成功!",
    "发布会议":"发布会议",
    "关联录屏":"关联录屏",
    "已关联":"已关联",
    "请输入会议名称":"请输入会议名称",
    "会议封面":"会议封面",
    "点击选择时间":"点击选择时间",
    "会议描述":"会议描述",
    "会议名称不允许为空":"会议名称不允许为空",
    "会议结束时间不能小于开始时间":"会议结束时间不能小于开始时间",
    "名称":"名称",
    "请输入名称内容":"请输入名称内容",
    "视频内容":"视频内容",
    "描述":"描述",
    "编辑文章":"编辑文章",
    "视频封面":"视频封面",
    "编辑视频内容":"编辑视频内容",
    "视频内容不允许为空":"视频内容不允许为空",
    "名称不允许为空":"名称不允许为空",
    "视频":"视频",
    "申请加入虚拟教研室可以和名师一起探讨教学哦":"申请加入虚拟教研室可以和名师一起探讨教学哦～",
    "暂无会议简介":"暂无会议简介",
    "展开":"展开",
    "参与":"参与",
    "相关推荐":"相关推荐",
    "次浏览":"次浏览",
    "条评论":"条评论",
    "暂无相关推荐":"暂无相关推荐",
    "个人版":"个人版",
    "企业版":"企业版",
    "有回放":"有回放",
}
